export const NEWTON_SEQUENCE = [
  {
    id: 'newton1',
    gameId: 'newton1',
    title: "Newton's First Law",
    shortTitle: 'First Law',
    description: 'Explore inertia and why objects keep moving unless a force changes them.'
  },
  {
    id: 'newton2',
    gameId: 'newton2',
    title: "Newton's Second Law",
    shortTitle: 'Second Law',
    description: 'Test how force, mass, and acceleration relate in interactive challenges.'
  },
  {
    id: 'newton3',
    gameId: 'newton3',
    title: "Newton's Third Law",
    shortTitle: 'Third Law',
    description: 'Discover action-reaction pairs through hands-on force interactions.'
  },
  {
    id: 'forces-motion-basics',
    gameId: 'forces-motion-basics',
    title: 'Force and Motion',
    shortTitle: 'Force and Motion',
    description: 'Apply all three laws in the integrated force and motion module.'
  }
];

export const isNewtonSequenceGame = (gameId) => (
  NEWTON_SEQUENCE.some((level) => level.gameId === gameId)
);
